// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChangeEmail-success-qL3nG {
  color: #16834b;
  font-weight: 500;
}

.ChangeEmail-error-JybOZ {
  color: #c0392b;
}

.ChangeEmail-backLink-jrvBN {
  display: inline-block;
  margin-top: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/routes/changeEmail/ChangeEmail.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB","sourcesContent":[".success {\n  color: #16834b;\n  font-weight: 500;\n}\n\n.error {\n  color: #c0392b;\n}\n\n.backLink {\n  display: inline-block;\n  margin-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"success": `ChangeEmail-success-qL3nG`,
	"error": `ChangeEmail-error-JybOZ`,
	"backLink": `ChangeEmail-backLink-jrvBN`
};
module.exports = ___CSS_LOADER_EXPORT___;
